import { render, staticRenderFns } from "./Template_6.vue?vue&type=template&id=65595f68&scoped=true"
import script from "./Template_6.vue?vue&type=script&lang=js"
export * from "./Template_6.vue?vue&type=script&lang=js"
import style0 from "./Template_6.vue?vue&type=style&index=0&id=65595f68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65595f68",
  null
  
)

export default component.exports